export const VITALS_ACTIVITY_TYPE = {
  STEPS: 'steps',
  DISTANCE: 'distance',
  BMI: 'bmi',
  WEIGHT: 'weight',
  HEIGHT: 'height',
  SATURATION: 'spo2',
  HEART_RATE: 'heart_rate',
  BLOOD_PRESSURE: 'blood_pressure',
  RESPIRATORY_RATE: 'respiratory_rate',
  BODY_SURFACE_AREA: 'bsa',
  BODY_TEMPERATURE: 'body_temperature',
  BLOOD_GLUCOSE: 'blood_glucose',
};

export const CHART_FILTERS_TYPE = {
  DAY: {
    title: '1 D',
    type: 'day',
  },
  WEEK: {
    title: '1 W',
    type: 'week',
  },
  MONTH: {
    title: '1 M',
    type: 'month',
  },
  QUARTER: {
    title: '3 M',
    type: 'quarter',
  },
  YEAR: {
    title: '1 Y',
    type: 'year',
  },
};

export const ORDER_MONTH_IN_YEAR = [
  'SEP',
  'OCT',
  'NOV',
  'DEC',
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
];

export const ORDER_TIME_DAY = [
  '12 AM',
  '1 AM',
  '2 AM',
  '3 AM',
  '4 AM',
  '5 AM',
  '6 AM',
  '7 AM',
  '8 AM',
  '9 AM',
  '10 AM',
  '11 AM',
  '12 PM',
  '1 PM',
  '2 PM',
  '3 PM',
  '4 PM',
  '5 PM',
  '6 PM',
  '7 PM',
  '8 PM',
  '9 PM',
  '10 PM',
  '11 PM',
];

export const ORDER_TIME_DAY_BMI_WEIGHT = [
  '',
  '12 AM',
  '1 AM',
  '2 AM',
  '3 AM',
  '4 AM',
  '5 AM',
  '6 AM',
  '7 AM',
  '8 AM',
  '9 AM',
  '10 AM',
  '11 AM',
  '12 PM',
  '1 PM',
  '2 PM',
  '3 PM',
  '4 PM',
  '5 PM',
  '6 PM',
  '7 PM',
  '8 PM',
  '9 PM',
  '10 PM',
  '11 PM',
  '',
];

export const PREVIOUS_PERIOD = 2;

export const ALLERGIE_TYPE = {
  SEVERE: 'severe',
  MODERATE: 'moderate',
  MILD: 'mild',
};

export const NORMAL_TYPE = ['N', 'n', 'normal'];

export const SCALE_BACKGROUND_COLOR = ['#ffc37d', '#7febb9', '#ff887d'];

export const HISTORIC_ONE_DAY_CALENDAR_TYPE = {
  sameDay: 'h:mm A',
  lastDay: 'h:mm A',
  lastWeek: 'h:mm A',
  sameElse: 'h:mm A',
};

export const DEVICE_CALENDAR_FORMATS = {
  sameDay: '[today], h:mm A',
  lastDay: '[yesterday], h:mm A',
  lastWeek: 'MMM D, h:mm A',
  sameElse: 'MMM D, h:mm A',
};

export const HISTORIC_CALENDAR_TYPE = {
  sameDay: '[Today]',
  sameElse: 'MMM D, YYYY',
  lastDay: 'MMM D, YYYY',
  lastWeek: 'MMM D, YYYY',
};

export const HISTORIC_SHORT_CALENDAR_TYPE = {
  sameDay: '[Today]',
  lastDay: 'MMM D',
  lastWeek: 'MMM D',
  lastMonth: 'MMM D',
  lastYear: 'MMM D, YYYY',
  sameElse: 'MMM D, YYYY',
};

export const HISTORIC_MONTHS_CALENDAR_TYPE = {
  sameDay: '[Today], h:mm A',
  sameElse: 'MMM D, YYYY, h:mm A',
  lastDay: 'MMM D, YYYY, h:mm A',
  lastWeek: 'MMM D, YYYY, h:mm A',
};

export const FITNESS_ACCOUNT_TYPE = {
  FITBIT: 'fitbit',
  WITHINGS: 'withings',
  GOOGLE_FIT: 'google_fit',
};

export const ACCOUNT_REGISTER_REDIRECT = {
  SUCCESS: 'register-device-account-success',
  ERROR: 'register-device-account-error',
};

export const MAX_ADDED_ACCOUNT = 4;

export const TABS_PATIENT_PORTAL = {
  VITALS_AND_ACTIVITY: 'vitals_and_activity',
  ENCOUNTERS: 'encounters',
  MEDICATIONS: 'medications',
  IMMUNIZATIONS: 'immunizations',
  LAB_TEST_RESULT: 'lab_and_test_results',
  ALLERGIES: 'allergies',
  CONDITIONS: 'conditions',
  SOCIAL_HISTORY: 'social_histories',
  FAMILY_HISTORY: 'family_histories',
  HEALTH_RECORD: 'health_record',
  ACTIVITY_LOG: 'activity_log',
  PROCEDURES: 'procedures',
};

export const CUSTOM_CHANNEL = null;
export const ALL_MEMBERS_SUBCHANNEL = 'all_members';
export const CIRCLE_OF_CARE_SUBCHANNEL = 'circles_of_care';
export const FAMILY_CIRCLE_SUBCHANNEL = 'family_circle';
export const NOTIFICATIONS_SUBCHANNEL = 'notifications';
export const ACTIVITIES_SUBCHANNEL = 'activities';

export const INVALID_DATE = 'Invalid date';

export const HEALTH_RECORD_DOC_TYPE = {
  XML: { fileType: 'xml', mimeType: 'text/xml' },
  PDF: { fileType: 'pdf', mimeType: 'application/pdf' },
  TXT: { fileType: 'txt', mimeType: 'text/plain' },
  ZIP: { fileType: 'zip', mimeType: 'application/zip' },
};

export const ACTIVITY_LOG_ROLE = {
  CAREGIVER: 'caregiver',
  PROVIDER: 'provider',
  GUARDIAN_PROXY: 'guardian/proxy',
  PATIENT: 'patient',
  PROXY: 'proxy',
  GUARDIAN: 'guardian',
  PARENT: 'parent',
};

export const ACTIVITY_LOG_ACTION_TYPE = {
  SHARE_CHAT: 'share_ccd_file_chat',
  SHARE_EMAIL: 'share_ccd_file_email',
  DOWNLOAD: 'download_ccd_file',
  GET_ACCESS: 'get_ccd_info_access',
  VIEW: 'view_ccd_file',
};

export const ACTIVITY_LOG_USER_ACTION_TYPE = {
  DOWNLOAD: 'download',
  VIEW: 'view',
};

export const THICKNESS_BY_Y_AXIS = 1.05;

export const MAYO_CLINIC_URL =
  'https://www.mayoclinic.org/symptoms/hypoxemia/basics/definition/sym-20050930';

export const DATA_SOURCE_TYPE = {
  CCD: 'ccd',
  DEVICES: 'devices',
  ALL_SOURCES: 'all_sources',
  LOCAL: 'local',
  APPLE: 'apple',
  FITBIT: 'fitbit',
  WITHINGS: 'withings',
  GOOGLE_FIT: 'google_fit',
  TENOVI: 'tenovi',
  I_HEALTH: 'ihealth',
};

export const COMPLETE_DATE_FORMAT = 'MMM DD, YYYY, h:mm A';



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/constants.js